import { __awaiter, __extends, __generator } from "tslib";
import { StratusClient } from '../stratus-client';
var defaultHeaders = {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
};
var defaultValue = '--';
/**
 * Subscriptions API
 * url: cc-gw.hpcloud.hp.com/
 * endpiont: cors/v1/subscriptions
 * stacks:
 * - dev/pie = 'daily'
 * - stage = 'staging'
 * - prod = ''
 */
var SubscriptionsApiClient = /** @class */ (function (_super) {
    __extends(SubscriptionsApiClient, _super);
    function SubscriptionsApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * List all subscriptions of a given printer and service.
     * @param {object} { product number, serial number, cloud id, device uuid, tenant id }
     * @returns {Promise<AxiosResponse>} The outcome of the request.
     */
    SubscriptionsApiClient.prototype.list = function (_a) {
        var productNumber = _a.productNumber, serialNumber = _a.serialNumber, deviceId = _a.deviceId, deviceUuid = _a.deviceUuid, deviceTenantId = _a.deviceTenantId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        params: {
                            product_number: productNumber !== null && productNumber !== void 0 ? productNumber : defaultValue,
                            serial_number: serialNumber !== null && serialNumber !== void 0 ? serialNumber : defaultValue,
                            device_id: deviceId !== null && deviceId !== void 0 ? deviceId : defaultValue,
                            service_id: "HP-Partnerlink" /* ServiceId.PARTNERLINK */,
                            device_uuid: deviceUuid !== null && deviceUuid !== void 0 ? deviceUuid : defaultValue,
                            fq_tenant_id: deviceTenantId !== null && deviceTenantId !== void 0 ? deviceTenantId : defaultValue,
                        },
                        headers: defaultHeaders,
                    })];
            });
        });
    };
    /**
     * Connect to an existing subscription for the provided printer and service.
     * @param {object} { product number, serial number, cloud id, partnerlink account id, device uuid, tenant id }
     * @returns {Promise<AxiosResponse>} The outcome of the request.
     */
    SubscriptionsApiClient.prototype.connect = function (_a) {
        var productNumber = _a.productNumber, serialNumber = _a.serialNumber, deviceId = _a.deviceId, accountId = _a.accountId, deviceUuid = _a.deviceUuid, deviceTenantId = _a.deviceTenantId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        data: {
                            product_number: productNumber !== null && productNumber !== void 0 ? productNumber : defaultValue,
                            serial_number: serialNumber !== null && serialNumber !== void 0 ? serialNumber : defaultValue,
                            device_id: deviceId !== null && deviceId !== void 0 ? deviceId : defaultValue,
                            service_id: "HP-Partnerlink" /* ServiceId.PARTNERLINK */,
                            account_id: accountId !== null && accountId !== void 0 ? accountId : defaultValue,
                            device_uuid: deviceUuid !== null && deviceUuid !== void 0 ? deviceUuid : defaultValue,
                            fq_tenant_id: deviceTenantId !== null && deviceTenantId !== void 0 ? deviceTenantId : defaultValue,
                        },
                        headers: defaultHeaders,
                    })];
            });
        });
    };
    /**
     * Disconnect from existing subscription for the provided printer and service.
     * @param {object} { product number, serial number, cloud id, partnerlink account id, device uuid, tenant id }
     * @returns {Promise<AxiosResponse>} The outcome of the request.
     */
    SubscriptionsApiClient.prototype.disconnect = function (_a) {
        var productNumber = _a.productNumber, serialNumber = _a.serialNumber, deviceId = _a.deviceId, accountId = _a.accountId, deviceUuid = _a.deviceUuid, deviceTenantId = _a.deviceTenantId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.delete({
                        params: {
                            product_number: productNumber !== null && productNumber !== void 0 ? productNumber : defaultValue,
                            serial_number: serialNumber !== null && serialNumber !== void 0 ? serialNumber : defaultValue,
                            device_id: deviceId !== null && deviceId !== void 0 ? deviceId : defaultValue,
                            service_id: "HP-Partnerlink" /* ServiceId.PARTNERLINK */,
                            account_id: accountId !== null && accountId !== void 0 ? accountId : defaultValue,
                            device_uuid: deviceUuid !== null && deviceUuid !== void 0 ? deviceUuid : defaultValue,
                            fq_tenant_id: deviceTenantId !== null && deviceTenantId !== void 0 ? deviceTenantId : defaultValue,
                        },
                        headers: defaultHeaders,
                    })];
            });
        });
    };
    return SubscriptionsApiClient;
}(StratusClient));
export { SubscriptionsApiClient };
//# sourceMappingURL=subscriptions-api.js.map